import * as React from 'react';
import px from 'prop-types';
import { useSelector } from 'react-redux';
import { ProductRating as Rating } from 'Common/components/product';
import { product } from '~features';

let yotpoInitTimer = null;
function scheduleYotpoInit() {
    clearTimeout(yotpoInitTimer);
    yotpoInitTimer = setTimeout(() => window.yotpoWidgetsContainer?.initWidgets?.(), 200);
}

export default function ProductRating({ writeReviewAnchor, reviewProviderEntityId = "", ...props }) {
    const productInfo =  useSelector(product.selectors.getProduct);
    const resolvedEntityId = reviewProviderEntityId.length > 0 ? reviewProviderEntityId : productInfo?.ReviewProviderEntityId;

    React.useEffect(() => {
        if (resolvedEntityId) scheduleYotpoInit();
    }, [resolvedEntityId]);

    return (
        <Rating
            {...props}
            reviewCount={productInfo?.ReviewsCount}
            writeReviewAnchor={writeReviewAnchor || ""}
            isDiscontinued={productInfo?.ItemStatus === 'Discontinued'}
            reviewProviderEntityId={resolvedEntityId}
        />
    );
}

ProductRating.propTypes = {
    writeReviewAnchor: px.string,
    reviewProviderEntityId: px.string
};
